import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { AddConsentUseCase } from './AddConsentUseCase';
import { GetConsentUseCase } from './GetConsentUseCase';
import { GetPPVEventConfigUseCase } from './GetPPVEventConfigUseCase';
import { GetPPVCountryConfigUseCase } from './GetPPVCountryConfigUseCase';
import { PPVPurchaseUseCase } from './GetPPVPurchaseUseCase';

export const initializeUserRegistrationUseCases = (container: Container) => {
    container.register(DI.USECASES.IAddConsentUseCase, {
        useClass: AddConsentUseCase,
    });
    container.register(DI.USECASES.IGetConsentUseCase, {
        useClass: GetConsentUseCase,
    });
    container.register(DI.USECASES.IGetPPVEventConfigUseCase, {
        useClass: GetPPVEventConfigUseCase,
    });
    container.register(DI.USECASES.IGetPPVCountryConfigUseCase, {
        useClass: GetPPVCountryConfigUseCase,
    });
    container.register(DI.USECASES.IPPVPurchaseUseCase, {
        useClass: PPVPurchaseUseCase,
    });
};
